import React from 'react';
import Icon from '@/components/ui/AppIcon';

const ContactCTA: React.FC = () => {
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-br from-primary via-navy-dark to-charcoal relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(212,175,55,0.15),transparent_50%)]" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-accent/20 rounded-full mb-8 backdrop-blur-sm">
            <Icon name="SparklesIcon" size={20} className="text-accent" variant="solid" />
            <span className="text-accent font-semibold text-sm uppercase tracking-wider">
              Ready to Get Started?
            </span>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-serif font-bold text-white mb-6 leading-tight">
            Your Justice, Our Commitment
          </h2>
          
          <p className="text-xl text-white/80 mb-12 leading-relaxed">
            Don't face your legal challenges alone. Contact Lubbert Associates LLC today for experienced, compassionate legal representation that puts your interests first.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+18078084167"
              className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-accent to-gold-dark text-primary font-bold text-lg rounded-lg shadow-subtle hover:shadow-elevation-sm hover:scale-102 transition-all duration-300 flex items-center justify-center space-x-3"
            >
              <Icon name="PhoneIcon" size={24} variant="solid" />
              <span>Call Now: +1-807-808-4167</span>
            </a>
            
            <a
              href="mailto:contact@lubbertassociates.com"
              className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-bold text-lg rounded-lg border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-300 flex items-center justify-center space-x-3"
            >
              <Icon name="EnvelopeIcon" size={24} variant="outline" />
              <span>Send Email</span>
            </a>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <Icon name="ShieldCheckIcon" size={32} className="text-accent mx-auto mb-3" variant="solid" />
              <h3 className="text-white font-semibold mb-2">Confidential</h3>
              <p className="text-white/70 text-sm">
                Your information is protected and secure
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <Icon name="ClockIcon" size={32} className="text-accent mx-auto mb-3" variant="solid" />
              <h3 className="text-white font-semibold mb-2">Fast Response</h3>
              <p className="text-white/70 text-sm">
                We respond within 24 hours
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <Icon name="CheckBadgeIcon" size={32} className="text-accent mx-auto mb-3" variant="solid" />
              <h3 className="text-white font-semibold mb-2">No Obligation</h3>
              <p className="text-white/70 text-sm">
                Free initial consultation
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;